var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { paths } from "frontend/src/pages/paths";
import { Role } from "frontend/src/shared/types/role";
import { LoginPage } from "./guest/login/page";
import { RegisterPage } from "./guest/register";
import { businessRoutes } from "./business";
import { withRole } from "../routes-guards";
import { adminRoutes } from "./admin";
import { rightholderRoutes } from "./rightholder";
import { ForgotPasswordPage } from "./guest/forgot-password/page";
import { ResetPasswordPage } from "./guest/reset-password/page";
import { employeeRoutes } from "./employee";
export var routes = __spreadArray(__spreadArray(__spreadArray(__spreadArray([
    {
        path: paths.login(),
        role: Role.Guest,
        Component: LoginPage,
    },
    {
        path: paths.register(),
        role: Role.Guest,
        Component: RegisterPage,
    },
    {
        path: paths.password.forgot(),
        role: Role.Guest,
        Component: ForgotPasswordPage,
    },
    {
        path: paths.password.reset(),
        role: Role.Guest,
        Component: ResetPasswordPage,
    }
], __read(businessRoutes), false), __read(adminRoutes), false), __read(rightholderRoutes), false), __read(employeeRoutes), false).map(function (_a) {
    var Component = _a.Component, role = _a.role, roles = _a.roles, route = __rest(_a, ["Component", "role", "roles"]);
    var allowedRouteRoles = roles !== null && roles !== void 0 ? roles : [role];
    return __assign(__assign({}, route), { Component: withRole(Component, allowedRouteRoles) });
});
